import React from 'react';
import { footer } from './fullscreenOverlay.styles';
import type { FullscreenOverlayFooterProps } from './types';

/**
 * FullscreenOverlayFooter Component
 *
 * Footer section for action buttons or additional content.
 * Supports different layout variants and is hidden for media variant.
 *
 * @example Button layout (right-aligned)
 * <FullscreenOverlay.Footer variant="buttons">
 *   <Button>Cancel</Button>
 *   <Button>Apply</Button>
 * </FullscreenOverlay.Footer>
 *
 * @example Equal-width buttons
 * <FullscreenOverlay.Footer variant="equal-width">
 *   <Button>Apply</Button>
 *   <Button>Tour</Button>
 *   <Button>Contact</Button>
 * </FullscreenOverlay.Footer>
 *
 * @example Text content
 * <FullscreenOverlay.Footer variant="text">
 *   <p>Additional information or disclaimers</p>
 * </FullscreenOverlay.Footer>
 */
export const FullscreenOverlayFooter = ({
  children,
  variant = 'buttons',
  overlayVariant = 'standard',
}: FullscreenOverlayFooterProps) => {
  // Don't render footer for media variant
  if (overlayVariant === 'media') {
    return null;
  }

  return <footer className={footer({ variant, overlayVariant })}>{children}</footer>;
};
